import { Box, Button, Grid, Modal, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import theme from "../../../theme/theme";

import { useDispatch } from "react-redux";
import { rescheduleMeetingApi } from "../../../API/schedule";
import { getUsersApi, getUsersByCompanyApi } from "../../../API/users";
import { updateMeetingSuccess as updateMeetingAction } from "../../../store/actions/schedule";
import { errorResponseHandler, successResponseHandler } from "../../../utils/reposeAlert";
import MeetingDatePicker from "../../Meeting/MeetingDatePicker";
import { validateMeetingTimes } from "../../../utils/meetingStatus";
import MeetingInput from "../../Meeting/MeetingInput";
import MeetingMultipleSelection from "../../Meeting/MeetingMultipleSelection";
import MeetingSingleSelection from "../../Meeting/MeetingSingleSelection";
import MeetingTextarea from "../../Meeting/MeetingTextarea";
import SharedButton from "../../Shared/SharedButton";
import { fromWallClockDate, toWallClockDate } from "../../../utils/formateDate";

const RescheduleModal = ({ openModal, toggleModal, meeting }) => {
  const dispatch = useDispatch();
  const [title, setTitle] = useState("");
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [startTimeToSubmit, setStartTimeToSubmit] = useState(null);
  const [endTimeToSubmit, setEndTimeToSubmit] = useState(null);
  const [description, setDescription] = useState("");
  const [selectedCompanies, setSelectedCompanies] = useState(null);
  const [selectedInvitees, setSelectedInvitees] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [inviteeOptions, setInviteeOptions] = useState([]);
  const [disabledAddMeeting, setDisabledAddMeeting] = useState(false);

  const handleStartTimeChange = (date) => {
    setStartTimeToSubmit(toWallClockDate(date));
    setStartTime(date);
    const endDate = new Date(date);
    endDate.setHours(endDate.getHours() + 1);
    setEndTimeToSubmit(toWallClockDate(endDate));
    setEndTime(endDate);
    setSelectedCompanies(null);
    setSelectedInvitees([]);
  };
  const handleEndTimeChange = (date) => {
    setEndTimeToSubmit(toWallClockDate(date));
    setEndTime(date);
    setSelectedCompanies(null);
    setSelectedInvitees([]);
  };

  const handleUpdateMeeting = async () => {};

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "100%",
      md: "45rem",
    },
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
  };

  useEffect(() => {
    setTitle(meeting.title);
    setDescription(meeting.description);
    // Show the stored wall-clock in the local pickers, and seed the submit
    // values with the original instant so an unchanged save round-trips.
    setStartTime(fromWallClockDate(meeting.startDate));
    setEndTime(fromWallClockDate(meeting.endDate));
    setStartTimeToSubmit(new Date(meeting.startDate));
    setEndTimeToSubmit(new Date(meeting.endDate));
    setSelectedCompanies({ name: meeting.owner.company.name, id: meeting.owner.company.id });
    let invitees = [];

    // eslint-disable-next-line array-callback-return
    meeting.invitations.map((item, index) => {
      invitees.push({
        name: `${item.registration.firstName} ${item.registration.lastName} - (${item.registration.position})`,
        id: item.registration.id,
      });
    });
    setSelectedInvitees(invitees);
    getCompanies();
    resetCompanyMembers();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  const resetCompanyMembers = async () => {
    await getUsersByCompanyApi(meeting.owner.company.id, meeting.startDate, meeting.endDate)
      .then((response) => {
        if (response.status === 200) {
          let invitees = [];
          const users = response.data?.data ?? response.data;

          // eslint-disable-next-line array-callback-return
          users.map((item) => {
            invitees.push({
              name: `${item.firstName} ${item.lastName} - (${item.position})`,
              id: item.id,
              status: item?.status || "available",
            });
          });
          setInviteeOptions(invitees);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally({});
  };

  const getCompanies = async () => {
    await getUsersApi()
      .then((response) => {
        if (response.status === 200) {
          let companies = [];

          // eslint-disable-next-line array-callback-return
          response.data.data.map((item) => {
            if (item.company && companies.findIndex((x) => x.id === item.company.id) === -1) {
              companies.push({ name: item.company.name, id: item.company.id });
            }
          });
          // Sort company names alphabetically (case-insensitive) for the dropdown.
          companies.sort((a, b) =>
            a.name.toLowerCase().localeCompare(b.name.toLowerCase())
          );
          setCompanyOptions(companies);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally({});
  };

  const companySelectHandler = async (company) => {
    if (!company || !startTime || !endTime) {
      setSelectedCompanies(null);
      setSelectedInvitees([]);
      setInviteeOptions([]);
      return;
    }
    setSelectedCompanies(company);
    setSelectedInvitees([]);
    await getUsersByCompanyApi(company.id, startTimeToSubmit.toISOString(), endTimeToSubmit.toISOString())
      .then((response) => {
        if (response.status === 200) {
          let invitees = [];
          const users = response.data?.data ?? response.data;

          // eslint-disable-next-line array-callback-return
          users.map((item, index) => {
            invitees.push({
              name: `${item.firstName} ${item.lastName} - (${item.position})`,
              id: item.id,
              status: item?.status || "available",
            });
          });
          setInviteeOptions(invitees);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally({});
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // Validate the picked times (item 1/2/3): 9 AM–4:45 PM start, end by 5 PM,
    // same day.
    const timeError = validateMeetingTimes(startTime, endTime);
    if (timeError) {
      errorResponseHandler("Invalid Time", timeError);
      return;
    }

    setDisabledAddMeeting(true);
    if (!disabledAddMeeting) {
       
      const addScheduleData = {
        title,
        description,
        startDate: startTimeToSubmit === null ? startTime.toISOString() : startTimeToSubmit.toISOString(),
        endDate: endTimeToSubmit === null ? endTime.toISOString() : endTimeToSubmit.toISOString(),
        inviteeIds: selectedInvitees.map((invite) => {
          return invite.id;
        }),
      };

      await rescheduleMeetingApi(meeting.id, addScheduleData)
        .then((response) => {
          successResponseHandler(`Updated`, "Schedule updated successfully");
          dispatch(updateMeetingAction(response.data));
          toggleModal(false);
        })
        .catch((error) => {
          const msg = error.response?.data || error.message;
          errorResponseHandler(`Failed`, msg);
        })
        .finally(() => {
          setDisabledAddMeeting(false);
        });
    }
  };

  return (
    <Modal
      open={openModal}
      onClose={() => toggleModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        zIndex: 10,
      }}
    >
      <Paper elevation={3} sx={modalStyle}>
        <Typography
          variant="h4"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: "bold",
            marginBottom: "2rem",
          }}
        >
          Update Meeting
        </Typography>
        <form onSubmit={submitHandler}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MeetingInput label="Meeting title" title={title} setTitle={setTitle} />
            </Grid>
            <Grid item xs={12} md={6}>
              <MeetingDatePicker label="Start Time" handleChange={handleStartTimeChange} value={startTime} />
            </Grid>
            <Grid item xs={12} md={6}>
              <MeetingDatePicker label="End Time" handleChange={handleEndTimeChange} value={endTime} />
            </Grid>
            <Grid item xs={12}>
              <MeetingTextarea description={description}  setDescription={setDescription} />
            </Grid>
            {companyOptions.length ? (
              <Grid item xs={12} md={12}>
                <MeetingSingleSelection
                  options={companyOptions}
                  selected={selectedCompanies}
                  setSelected={companySelectHandler}
                  disabled={!startTime || !endTime}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} md={12}>
              <MeetingMultipleSelection
                options={inviteeOptions}
                selected={selectedInvitees}
                setSelected={setSelectedInvitees}
                disabled={!selectedCompanies}
               
              />
            </Grid>
            <Grid item xs={12}>
              <Box
                sx={{
                  borderTop: `1px solid ${theme.palette.primary.main}`,
                  paddingTop: "1rem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button variant="outlined" color="secondary" onClick={() => toggleModal(false)}>
                  Cancel
                </Button>
                <SharedButton
                  color="primary"
                  text="Update"
                  onAction={handleUpdateMeeting}
                  disabled={disabledAddMeeting}
                  type="submit  "
                />
              </Box>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Modal>
  );
};

export default RescheduleModal;